import Pusher from "pusher-js";

import {
  getPusherConfigs,
  getBroadcastingAuthEndpoint,
} from "@/config/environmentUtils";
import { useAuthContext } from "@/services/auth";

import { getPusherAuthorizer } from "./broadcast.helper";

export const useBroadcastInit = () => {
  const { token } = useAuthContext();
  const { appKey, cluster } = getPusherConfigs();

  if (!appKey || !cluster) {
    return null;
  }

  return new Pusher(appKey, {
    cluster: cluster,
    forceTLS: true,
    authEndpoint: getBroadcastingAuthEndpoint(),
    auth: {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    authorizer: getPusherAuthorizer(token),
  });
};
